import React, {useState, useContext, useRef, useEffect} from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import ContentModal from './ContentModal';
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Web3 from "web3";
import Context from "../../../context/context";
import Swal  from "sweetalert2";
import Staking from '../abi/ptgcToken/Staking.json';
import DEXRouter from '../abi/Router.json';
import UFO from '../abi/Ufo.json';
import { formatUnits, parseUnits } from "ethers";
import TransactionStatus from "../TxnStatus";
import { sendGetRequest, providerURL, txAfterDone, txDone, txStart } from '../../../helper/Helper';

const Sections2 = () => {
  const {account, onConnect, providers, pTGCVolume, ptgcPrice, ufoPrice, plsPrice } = useContext(Context);
  const { ref, inView } = useInView({ triggerOnce: true });
  const [isOpen, setIsOpen] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("leaderboard");
  const [PLSBalance, setPLSBalance] = useState(0);
  const [UFOBalance, setUFOBalance] = useState(0);
  const [PLSAmount, setPLSAmount] = useState('');
  const [UFOAmount, setUFOAmount] = useState('');
  const [slippage, setSlippage] = useState(7);
  const [open, setOpen] = useState(false);

  const openModalWithTab = (tab) => {
    setActiveTab(tab);
    setModalIsOpen(true);
  };

  const closeModal = () => setModalIsOpen(false);
  const dropdownRef = useRef(null);

 
  const dropdownRefSetting = useRef(null);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if(account) {
      getData();
    }
  }, [account]);

  useEffect(() => {
    handleToAmountChange();
  }, [PLSAmount]);

  const getData = async () => {
    const web3 = new Web3(providers);
    const UFOContract = new web3.eth.Contract(UFO.ABI, UFO.Contract);

    setPLSBalance(Number(formatUnits(await web3.eth.getBalance(account), 18)));
    setUFOBalance(Number(formatUnits(await UFOContract.methods.balanceOf(account).call(), 18)));
  }

  const handleToAmountChange = () => {
    if (!isNaN(parseFloat(PLSAmount))) {
      const pTGC_TRANSFER_FEE = 0;
      const PLATFORM_FEE = 0;    
      const estimatedInput = (parseFloat(PLSAmount) * plsPrice) / (1 - pTGC_TRANSFER_FEE) / (1 - PLATFORM_FEE) / ufoPrice;
      setUFOAmount(estimatedInput.toLocaleString('en-US', { maximumFractionDigits: 2 }));
    }
  };

  const swapPTGC = async () => {
      const web3 = new Web3(providers);
      const routerContract = new web3.eth.Contract(DEXRouter.ABI, DEXRouter.Contract);
      const amount = parseUnits(String(PLSAmount || "0"), 18);
      const deadline = Math.floor(Date.now() / 1000) + 60 * 60;
      const WPLS = '0xA1077a294dDE1B09bB078844df40758a5D0f9a27';
      const path = [WPLS, UFO.Contract];

      try {
          const amounts = await routerContract.methods.getAmountsOut(amount, path).call();
          const expectedOut = parseInt(amounts[1]);
          const slippageOutput = (expectedOut * slippage) / (100);
          const minOutput = (expectedOut - slippageOutput);

          await routerContract.methods.swapExactETHForTokensSupportingFeeOnTransferTokens(minOutput, path, account, deadline).send({
              from: account,
              value: amount,
          }).on('transactionHash', function(payload) {
              txStart();
          }).on('error', function(error) {
              Swal.fire({
                  title: "Please try again",
                  text: error.message,
                  icon: "error",
                  showCancelButton: false,
                  confirmButtonText: "Ok",
                  showCloseButton: true,
                  customClass: {
                      confirmButton: "btn btn-danger"
                  }
              });
          }).then(function(receipt) {
              txDone()
              setTimeout(() => {
                txAfterDone()
              }, 2000)
              getData();
          });
      } catch (error) {
          txDone();
          txAfterDone();
          Swal.fire({
              title: "Please try again",
              text: error.message,
              icon: "error",
              showCancelButton: false,
              confirmButtonText: "Ok",
              showCloseButton: true,
              customClass: {
                  confirmButton: "btn btn-danger"
              }
          });
      }
  }
return (
  <>
  <section className="boXSec StatisticsSec5  boXSecUp padsec pt-0 UFOSEC">
    <div className="container">
      <div className="row">
        <div className="col-lg-4">
          <div className="statsSN subcontent" data-aos="fade-up"  data-aos-delay="300" data-aos-duration="1600">
            <h2 className="mb-1 gradient-stroke-text">UFO Videos</h2>
            <p className="mb-0">Explore our curated playlist of educational videos that dive into UFO, its innovative value generation system, and practical tips for interacting with the dApp and calculators.</p>
            <div className=" pt-2 ">
              <div className="someBtnsmod100 someBtns SRTOP row">
                <div className="col-12">
                  <button onClick={() => openModalWithTab("videos")} className="borderbtn mybtn w-100 d-flex justify-content-between align-items-center mt-4">
                    <span>View Now</span> 
                    <img src="./images/circle_arrow.svg" className="img-fluid"/>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="statsSN subcontent" data-aos="fade-up"  data-aos-delay="300" data-aos-duration="1200">
            <h2 className="gradient-stroke-text">Need help getting UFO?</h2>
            <p className="mb-0">Check out our comprehensive guide on how to buy UFO, complete with helpful links, a detailed step-by-step walkthrough, and supporting videos.</p>
            <div className="">
              <div className="someBtnsmod100 someBtns SRTOP  row ">
                <div className="col-12">
                  <button onClick={() => openModalWithTab("help")} className="borderbtn mybtn w-100 d-flex justify-content-between align-items-center mt-4"><span>View Now</span> <img src="./images/circle_arrow.svg" className="img-fluid" /></button>
                </div>
              </div>
            </div>
          </div>
        </div>
         <div className="col-lg-4">
            <div className="snXBig snXBig2 " data-aos="fade" data-aos-delay="1000" data-aos-duration="800">
              <div className="statsSN subcontent snXIn snX mb-0 text-start ">
                  <div>
                      <h2 className="mt-2 mb-1 gradient-stroke-text">Swap UFO</h2>
                      <p className="mb-2 w-100">Instantly swap tokens at the best rates with adjustable slippage tolerance.</p>
                      <hr className="my-2" />
                      <div className="d-flex justify-content-between align-items-center gap-1 flex-wrap ">
                          <p className=""><b>Quick Swap</b> <span className="byby">via PulseX</span></p>
                          <div className="position-relative" ref={dropdownRefSetting}>
                            {/* ⚙️ Icon */}
                            <button
                              className="btn btn-dark p-1"
                              style={{ borderRadius: "8px" }}
                              onClick={() => setOpen(!open)}
                            >
                              <i className="fa-solid fa-gear"></i>
                            </button>

                            {/* Dropdown */}
                            {open && (
                              <div
                                className="position-absolute end-0 mt-2 p-3  text-white"
                                style={{
                                  width: "260px",
                                  borderRadius: "12px",
                                  border: "1px solid #2c2c2c",
                                  zIndex: 1000,
                                  background: '#1a1a1a'
                                }}
                              >
                                <h6 className="mb-2">Slippage Tolerance</h6>

                                <div className="d-flex gap-2 mb-2">
                                  {[0.1, 0.5, 1.0].map((val) => (
                                    <button
                                      key={val}
                                      className={`btn btn-sm ${
                                        slippage === val
                                          ? "btn-success btn-success-my"
                                          : "btn-outline-secondary btn-outline-secondary-my"
                                      }`}
                                      onClick={() => setSlippage(val)}
                                    >
                                      {val}%
                                    </button>
                                  ))}

                                 <input
                                    type="text"
                                    className="form-control form-control-sm bg-dark text-white"
                                    placeholder="%"
                                    style={{ width: "70px", borderColor: "#6c757d" }}
                                    value={slippage}
                                    inputMode="decimal"
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      if (!/^\d*\.?\d{0,2}$/.test(value)) return;

                                      if (value === "") {
                                        setSlippage("");
                                        return;
                                      }

                                      const num = Number(value);
                                      if (num <= 100) {
                                        setSlippage(value);
                                      }
                                    }}
                                  />
                                </div>
                                <p className="mb-0" style={{fontSize: '14px',lineHeight: '20px'}} >
                                  Higher slippage increases success chance but may result in worse rates
                                </p>
                              </div>
                            )}
                          </div>
                      </div>
                      <div className="swapInsn mb-3">
                          <div className="d-flex justify-content-between gap-1 flex-wrap">
                              <label>From</label>
                              <label>Balance: {parseFloat(PLSBalance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</label>
                          </div>
                          <div className="d-flex justify-content-between align-items-center gap-1 flex-wrap inputimg">
                              <input
                                type="text"
                                placeholder='0.00'
                                value={
                                  PLSAmount === "" || isNaN(Number(PLSAmount.toString().replace(/,/g, "")))
                                    ? ""
                                    : Number(PLSAmount.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                      })
                                }
                                onChange={async (e) => {
                                  let raw = e.target.value.replace(/,/g, "");

                                  if (raw === "") {
                                    await setPLSAmount("");
                                    return;
                                  }

                                  if (!/^\d*(\.\d{0,2})?$/.test(raw)) return;
                                  const num = Math.min(Number(raw), Number(PLSBalance));
                                  await setPLSAmount(num);
                                }}
                              />
                              <span><img src="./images/PLS.png" className="img-fluid" /> PLS</span>
                          </div>
                          <button className="swapIcon"><i className="fa-solid fa-rotate"></i></button>
                          <div className="d-flex justify-content-between gap-1 flex-wrap">
                              <label>To (estimated)</label>
                              <label>Balance: {parseFloat(UFOBalance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</label>
                          </div>
                          <div className="d-flex justify-content-between align-items-center gap-1 flex-wrap inputimg">
                              <input
                                type="text"
                                placeholder='0.00'
                                value={
                                  UFOAmount === "" || isNaN(Number(UFOAmount.toString().replace(/,/g, "")))
                                    ? ""
                                    : Number(UFOAmount.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                      })
                                }
                                disabled
                              />
                              <span><img src="./images/UFO.png" className="img-fluid" /> UFO</span>
                          </div>
                      </div>
                      <div className="swapInsn mb-3">
                          <div className="d-flex justify-content-between gap-1 flex-wrap mt-2">
                              <label>Rate</label>
                              <label style={{opacity:'1'}}>1 PLS ≈ {((1 * plsPrice) / ufoPrice).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 8})} UFO</label>
                          </div>
                          <div className="d-flex justify-content-between gap-1 flex-wrap">
                              <label>Slippage</label>
                              <label style={{opacity:'1'}}>{parseFloat(slippage).toFixed(2)}%</label>
                          </div>
                          <div className="d-flex justify-content-between gap-1 flex-wrap">
                              <label>Fee</label>
                              <label style={{opacity:'1'}}>0.3%</label>
                          </div>
                      </div>
                      <div className="someBtnsmod100 someBtns">
                        {
                          account ? 
                          <>
                          <button className="someSnbtn FFFFFF d-flex justify-content-between align-items-center mt-4" onClick={swapPTGC}>
                            <span>Swap Now</span> <div className="iconiconSR"> <img className="img-fluid" src="./images/circle_arrow.svg" /></div>
                          </button>
                          </>
                          :
                          <>
                          <button className="someSnbtn FFFFFF d-flex justify-content-between align-items-center mt-4" onClick={onConnect}>
                            <span>Connect Wallet</span> <div className="iconiconSR"> <img className="img-fluid" src="./images/circle_arrow.svg" /></div>
                          </button>
                          </>
                        }
                      </div>
                  </div>
              </div>
          </div>
      </div>
       
     <div className="col-lg-4">
          
          <div className="statsSN subcontent " data-aos="fade-up"  data-aos-delay="300" data-aos-duration="1600">
            <h2 className="mb-1 gradient-stroke-text">UFO Pools</h2>
            <p className="mb-0">UFO Token stands as a pivotal amplifier within The Grays ecosystem, strategically engineered to foster unity between the Richard Heart (RH) ecosystem and The Grays Currency. </p>
            <div className="mt-3">
              <div className="someBtnsmod100 someBtns SRTOP row">
                <div className="col-12">
                  <Link to='/ufo-pools' className="borderbtn mybtn w-100 d-flex justify-content-between align-items-center mt-4">
                    <span>View Now</span> 
                    <img src="./images/circle_arrow.svg" className="img-fluid"/>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="statsSN subcontent " data-aos="fade-up"  data-aos-delay="300" data-aos-duration="1600">
            <h2 className="mb-1 gradient-stroke-text">UFO Reward</h2>
            <p className="mb-0">Earn passive income by holding and staking UFO Tokens — get rewarded for supporting the PTGC ecosystem.</p>
            <div className="mt-4 pt-4">
              <div className="someBtnsmod100 someBtns SRTOP row">
                <div className="col-12">
                  <Link to='/ufo-reward' className="borderbtn mybtn w-100 d-flex justify-content-between align-items-center mt-4">
                    <span>View Now</span> 
                    <img src="./images/circle_arrow.svg" className="img-fluid"/>
                  </Link>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
  
      <ContentModal
        isOpen={modalIsOpen}
        onClose={closeModal}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      <TransactionStatus/>
  </>
  );
};

export default Sections2;